import React, { useEffect, useState } from 'react'
import { Col, Input, Row, FormGroup, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import Switch from 'react-switch'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumeric, isNotNumericDecimal } from 'context/Utilities'

const InstantOatmealNutritionReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Kcals: item.Kcals,
    Folate: item.Folate,
    Fiber: item.Fiber,
    WholeGrainCert: item.WholeGrainCert,
    Iron: item.Iron,
    Sucrose: item.Sucrose,
    Rounding: item.Rounding,
    UnderIronLimit: item.UnderIronLimit,
    UnderSucroseLimit: item.UnderSucroseLimit,
    ContainsNoSweeteners: item.ContainsNoSweeteners,
  })
  const methods = useFormContext()
  const {
    setSelectReviewer,
    setSwitchReviewer,
    onChangeReviewer,
    asterisk,
  } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const {
        Kcals,
        Folate,
        Fiber,
        WholeGrainCert,
        Iron,
        Sucrose,
        Rounding,
        UnderIronLimit,
        UnderSucroseLimit,
        ContainsNoSweeteners,
      } = item
      setPackaging({
        Kcals,
        Folate,
        Fiber,
        WholeGrainCert,
        Iron,
        Sucrose,
        Rounding,
        UnderIronLimit,
        UnderSucroseLimit,
        ContainsNoSweeteners,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={3}>
          <FormGroup>
            <p>
              <strong>Kcals per 100g dry cereal {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Kcals"
              type="number"
              step="1"
              defaultValue={packaging.Kcals}
              onKeyDown={e => {
                if (isNotNumeric(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 3,
                  message: '⚠ Kcals exceeds 3 characters.',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter Kcals per 100g dry cereal.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Kcals"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
          <br />
          <FormGroup>
            <p>
              <strong>Folate (mcg) per 100g dry cereal {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Folate"
              type="number"
              step="0.01"
              defaultValue={packaging.Folate}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 6,
                  message:
                    '⚠ Folate (mg) per 100g dry cereal exceeds 6 characters.',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter Folate (mg) per 100g dry cereal.',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Folate"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
          <br />
          <FormGroup>
            <p>
              <strong>Fiber (g) per 100g dry cereal {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Fiber"
              type="number"
              step="0.01"
              defaultValue={packaging.Fiber}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 6,
                  message:
                    '⚠ Fiber (g) per 100g dry cereal exceeds 6 characters.',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter Fiber (g) per 100g dry cereal.',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Fiber"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <p>
              <strong>Iron (mg) per 100g dry cereal {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Iron"
              type="number"
              step="0.01"
              placeholder={'Min 28mg iron per 100g dry cereal'}
              defaultValue={packaging.Iron}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 6,
                  message:
                    '⚠ Iron (mg) per 100g dry cereal exceeds 6 characters.',
                },
                min: {
                  value: 28,
                  message:
                    '⚠ Iron (mg) per 100g dry cereal is below the 28mg minimum allowed.',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter Iron (mg) per 100g dry cereal.',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Iron"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
          <br />
          <FormGroup>
            <p>
              <strong>
                I certify that this product contains at least 28mg iron per 100
                grams of dry cereal. {asterisk}
              </strong>
            </p>
            <Controller
              as={Switch}
              name="UnderIronLimit"
              id="UnderIronLimit"
              defaultValue={packaging.UnderIronLimit}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              rules={{
                validate: UnderIronLimit => UnderIronLimit === true,
              }}
              disabled={isDisabled}
            />
            <br />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="UnderIronLimit"
                message={
                  '⚠ You must certify that this product contains at least 28mg iron per 100 grams of dry cereal.'
                }
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
          <br />
          <hr />
          <FormGroup>
            <p>
              <strong>Using FDA rounding rule for iron</strong>
            </p>
            <Controller
              as={Switch}
              name="Rounding"
              id="Rounding"
              defaultValue={packaging.Rounding}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              disabled={isDisabled}
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <p>
              <strong>Added Sugar (g) per 100g dry cereal {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Sucrose"
              type="number"
              step="0.01"
              placeholder={'Max 21.2g added sugar'}
              defaultValue={packaging.Sucrose}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 6,
                  message:
                    '⚠ Added Sugar (g) per 100g dry cereal exceeds 6 characters.',
                },
                max: {
                  value: 21.2,
                  message:
                    '⚠ Added Sugar (g) per 100g dry cereal is above the 21.2g maximum allowed.',
                },
                required: {
                  value: true,
                  message:
                    '⚠ Please enter Added Sugar (g) per 100g dry cereal.',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Sucrose"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
          <br />
          <FormGroup>
            <p>
              <strong>
                I certify that this product contains no more than 21.2g added
                sugars per 100 grams of dry cereal. {asterisk}
              </strong>
            </p>
            <Controller
              as={Switch}
              name="UnderSucroseLimit"
              id="UnderSucroseLimit"
              defaultValue={packaging.UnderSucroseLimit}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              rules={{
                validate: UnderSucroseLimit => UnderSucroseLimit === true,
              }}
              disabled={isDisabled}
            />
            <br />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="UnderSucroseLimit"
                message={
                  '⚠ You must certify that this product contains no more than 21.2g sucrose and/or other sugars per 100 grams of dry cereal.'
                }
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
          <br />
          <hr />
          <FormGroup>
            <p>
              <strong>
                I certify that this product does not contain artificial
                sweeteners, reduced-calorie sweeteners, or no-calorie
                sweeteners. {asterisk}
              </strong>
            </p>
            <Controller
              as={Switch}
              name="ContainsNoSweeteners"
              id="ContainsNoSweeteners"
              defaultValue={packaging.ContainsNoSweeteners}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              rules={{
                validate: ContainsNoSweeteners => ContainsNoSweeteners === true,
              }}
              disabled={isDisabled}
            />
            <br />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="ContainsNoSweeteners"
                message={
                  '⚠ You must certify that this product does not contain artificial sweeteners, reduced-calorie sweeteners, or no-calorie sweeteners.'
                }
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <p>
              <strong>
                I certify that this product has a whole grain as the first
                ingredient . {asterisk}
              </strong>
            </p>
            <Controller
              as={Switch}
              name="WholeGrainCert"
              id="WholeGrainCert"
              defaultValue={packaging.WholeGrainCert}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              rules={{
                validate: WholeGrainCert => WholeGrainCert === true,
              }}
              disabled={isDisabled}
            />
            <br />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="WholeGrainCert"
                message={
                  '⚠ You must certify that this product has a whole grain as the first ingredient.'
                }
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

InstantOatmealNutritionReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default InstantOatmealNutritionReview
